import { Button } from '@/global/components/Button'
import { CategoriaEnum } from '@acme/auth'
import { Subscription } from '@cel_cash/core/types'
import RetryImage from 'assets/retry.png'
import { ContentGuide } from 'global/guides/ContentGuide'
import { useAuth } from 'hooks'
import { RefreshCwIcon } from 'lucide-react'
import { useState } from 'react'
import { Outlet, useOutletContext } from 'react-router-dom'
import {
    assinaturas,
    Cliente,
    clientes,
    PlanoFixo,
    planos as planosApi,
} from 'service/api'
import { NotFound } from 'templates/NotFound'

export default function PlanosPage() {
    const { decoded } = useAuth()
    const [retryDelay, setRetryDelay] = useState(1000)

    const {
        data: assinatura,
        isLoading: isLoadingAssinatura,
        isFetched,
    } = assinaturas.minhaAssinatura.useFetch({
        enabled: true,
        refetchOnWindowFocus: false,
    })

    const { data: cliente = {} as Cliente } = clientes.useFetchById(
        decoded?.cliente,
    )
    const { data: PlanoDiferenciado } = planosApi.useFetchById('diferenciado')

    const {
        data: planos,
        failureCount,
        refetch,
        isLoading: isLoadingPlanos,
    } = planosApi.useFetch({
        enabled: true,
        retryDelay(failureCount) {
            return failureCount * retryDelay
        },
        refetchOnWindowFocus: false,
    })

    const handleClick = () => {
        setRetryDelay(state => state * 1.5)
        refetch()
    }

    if (
        ![CategoriaEnum.Cliente, CategoriaEnum.Avaliacao].includes(
            decoded?.categoria,
        )
    )
        return <NotFound />

    if (failureCount >= 4) {
        return (
            <ContentGuide>
                <div className="flex justify-center items-center h-full flex-col gap-4">
                    <img
                        src={RetryImage}
                        alt="Erro ao carregar planos"
                        style={{ maxWidth: 180 }}
                    />
                    <h6 className="text-lg font-semibold -mt-8">
                        Ocorreu um erro ao buscar o recurso solicitado
                    </h6>

                    <Button
                        variant="outlined"
                        onClick={handleClick}
                        sx={{
                            mb: 10,
                        }}
                        startIcon={<RefreshCwIcon />}
                    >
                        Tentar novamente
                    </Button>
                </div>
            </ContentGuide>
        )
    }

    return (
        <Outlet
            context={{
                assinatura,
                planos,
                cliente,
                PlanoDiferenciado,
                isLoading: isLoadingAssinatura || isLoadingPlanos,
            }}
        />
    )
}

export const usePlanosContext = () => {
    return useOutletContext<{
        assinatura?: Subscription
        planos?: PlanoFixo[]
        cliente?: Cliente
        PlanoDiferenciado?: Cliente['PlanoDiferenciado'] | null
        isLoading: boolean
    }>()
}
